<template>
  <div>
    <div class="tutor-filter-block">
      <div class="title-text color_grey_dark text-uppercase">FILTERS</div>

      <div class="filter-parameters">
        <div class="form-row-data">
          <div class="form-title color_text font-weight-bold">Search</div>
          <div class="form-box position-relative">
            <input type="text" class="form-control" v-model="search_params.s" placeholder="Search">
            <div class="icon-search brand_accent font-20 position-absolute"></div>
          </div>
        </div>

        <div class="form-row-data">
          <div class="form-title color_text font-weight-bold">Subject</div>
          <div class="form-box">
            <select
              name
              id
              class="form-control"
              v-model="search_params.subject"
              @change="querySearch"
            >
              <option value>Select Subject</option>
              <option
                :value="subject.slug"
                v-for="(subject, index) in subject_list"
                :key="index"
              >{{ subject.name }}</option>
            </select>
          </div>
        </div>

        <div class="form-row-data">
          <div class="form-title color_text font-weight-bold">Curriculum</div>
          <div class="form-box">
            <select
              name
              id
              class="form-control"
              v-model="search_params.curriculum"
              @change="querySearch"
            >
              <option value>Select Curriculum</option>
              <option
                :value="curriculum.slug"
                v-for="(curriculum, index) in curriculum_list"
                :key="index"
                :selected="index === 0"
              >{{ curriculum.title }}</option>
            </select>
          </div>
        </div>

        <div class="form-row-data">
          <div class="form-title color_text font-weight-bold">Availability</div>

          <div
            class="form-box"
            style="margin-bottom:-10px"
            v-for="(week, index) in availability_weeks"
            :key="index"
          >
            <div class="checkbox checkbox-inline" style="padding-left:2px;">
              <label :for="week.value" class="pointer">
                <input type="checkbox" :id="week.value" :value="week.value" v-model="days">
                <span class="label_text font-14-5 color_text ml-2">
                  {{
                  week.title
                  }}
                </span>
              </label>
            </div>
          </div>
        </div>

        <div class="form-row-data">
          <div class="form-title color_text font-weight-bold">Gender</div>
          <div class="form-box">
            <select
              name
              id
              class="form-control"
              v-model="search_params.gender"
              @change="querySearch"
            >
              <option value>Select Gender</option>
              <option value="No preference">No Preference</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { debounce } from "lodash";
export default {
  name: "TutorFilterBlock",

  props: {
    curriculum_list: Array,
    subject_list: Array
  },

  data() {
    return {
      availability_weeks: [
        {
          title: "Sunday",
          value: "sunday"
        },
        {
          title: "Monday",
          value: "monday"
        },
        {
          title: "Tuesday",
          value: "tuesday"
        },
        {
          title: "Wednesday",
          value: "wednesday"
        },
        {
          title: "Thursday",
          value: "thursday"
        },
        {
          title: "Friday",
          value: "friday"
        },
        {
          title: "Saturday",
          value: "saturday"
        }
      ],
      search_params: {
        s: "",
        subject: "",
        curriculum: "",
        gender: "",
        day: ""
      },
      days: []
    };
  },
  watch: {
    "search_params.s": {
      handler: debounce(function(val) {
        if (val.length >= 3) this.getSearchParam();
        else if (val.length === 0) return;
      }, 2000)
    },

    days: {
      handler: debounce(function(val) {
        if (val.length > 0) {
          this.search_params.day = val.join(",");
          this.getSearchParam();
        }
      }, 2000)
    }
  },

  methods: {
    ...mapActions(["getSearchDetails"]),

    querySearch() {
      this.getSearchParam();
    },

    getSearchParam() {
      this.getSearchDetails(this.search_params)
        .then(response => {
          if (this.search_params.subject !== "") {
            this.$emit("search_subject", this.search_params.subject);
          }
          // if (response.data !== null || response.data === 200) {
          // console.log(response.data);
          this.$emit("filteredResult", response);
          // }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style lang="scss">
.tutor-filter-block {
  margin-bottom: 70px;

  .title-text {
    font-size: 15px;
    line-height: 19px;
    margin-bottom: 40px;
  }

  .form-row-data {
    margin-bottom: 20px;

    .form-title {
      font-size: 14px;
      line-height: 19px;
      margin-bottom: 10px;
    }

    .form-box {
      .icon-search {
        @include transform_center;
        z-index: 9;
        left: 91%;
      }
    }
  }
}
</style>
